import Actor from '../physics/Actor';

/**
 * A ConveyorBelt moves the player in its direction.
 * @extends Actor
*/
export default class ConveyorBelt extends Actor {
	constructor(mesh, speed = 500, state = true) {
		super(mesh);

		this._speed = 1100;
		this._activated = state;
		this._direction = ConveyorBelt.DIR_UP;
	}

	init() {
		super.init();
	}

	activate() {
		this._activated = true;
	}

	destroy() {
		super.destroy();
	}

	get direction() {
		return this._direction;
	}

	get speed() {
		return this._speed;
	}

	set direction(v) {
		this._direction = v;
	}

	set speed(v) {
		this._speed = v;
	}

	set state(v) {
		this._state = v;
	}

	get state() {
		return this._state;
	}

	get activated() {
		return this._activated;
	}
}

ConveyorBelt.DIR_LEFT = {v: -1, d: 'l', camrot: 180};
ConveyorBelt.DIR_UP = {v: -1, d: 'u', camrot: 90};
ConveyorBelt.DIR_RIGHT = {v: 1, d: 'r', camrot: 0};
ConveyorBelt.DIR_DOWN = {v: 1, d: 'd', camrot: 270};
